import { createFileRoute } from '@tanstack/react-router';
import { ClustersPage } from '@/features/foodcost/ClustersPage';

export const Route = createFileRoute('/_app/foodcost/cluster')({ component: ClustersPage });
